module.exports = ".gsc-control-cse {\n  font-family: Arial, sans-serif;\n  border-color: #000000;\n  background-color: #000000;\n}\n"